module.exports = __webpack_public_path__ + "img/logo-login.1512b3e.svg";